import { FC } from 'react';

import classes from './Heading3.module.css';

const Heading3: FC = ({ children }) => {
  return <div className={classes.root}>{children}</div>;
};

export default Heading3;
